import {
	ChangeDetectionStrategy,
	Component,
	input,
	model,
} from '@angular/core';
import { FormControl } from '@angular/forms';

import { BaseDirective } from '@valk-nx/core/lib/directives/base/base.directive';

import { SelectionCardCheckboxComponent } from './selection-card-checkbox/selection-card-checkbox';
import { SelectionCardRadioComponent } from './selection-card-radio/selection-card-radio';
import type { SelectionCardInterface } from './selection-card.interface';

@Component({
	selector: 'vp-selection-card',
	imports: [SelectionCardCheckboxComponent, SelectionCardRadioComponent],
	templateUrl: './selection-card.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectionCardComponent extends BaseDirective {
	controlType = input<'radio' | 'checkbox'>('radio');
	customFormControl = input<FormControl>(new FormControl());
	grid = input<'cols-1' | 'cols-2' | 'cols-3'>('cols-2');
	hasCardsAsMarkdown = input<boolean>(false);
	hasError = input<boolean>(false);
	isDisabled = input<boolean>(false);
	isReadonly = input<boolean>(false);
	isValid = input<boolean>(false);
	name = input<string>('');
	hideNativeInput = input<boolean>(false);
	stacked = input<boolean>(false);

	options = model<SelectionCardInterface[]>([]);
}
